import { Component, OnInit, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { TasksService } from '../../../../../core/services/tasks/tasks.service';
import { GroupTasksService } from '../../../../../core/services/tasks/group-tasks.service';

@Component({
  selector: 'app-tasks-badge',
  standalone: true,
  imports: [TooltipModule],
  templateUrl: './tasks-badge.html',
})
export class TasksBadge implements OnInit {
  private readonly tasksService = inject(TasksService);
  private readonly groupTasksService = inject(GroupTasksService);
  private readonly router = inject(Router);

  readonly pendingCount = computed(
    () => this.tasksService.pendingCount() + this.groupTasksService.pendingCount(),
  );

  readonly tooltip = computed(() => {
    const count = this.pendingCount();
    if (count === 0) return 'No hay tareas pendientes';
    return count === 1 ? '1 tarea pendiente' : `${count} tareas pendientes`;
  });

  ngOnInit(): void {
    this.tasksService.refreshPendingCount();
    this.groupTasksService.refreshPendingCount();
  }

  goToTasks(): void {
    this.router.navigate(['/crm/tasks']);
  }
}
